export default "__VITE_ASSET__OnWtzVUX__"